const allowedContentTags = new Set([
  'a', 'abbr', 'article', 'aside', 'b', 'blockquote', 'br', 'caption', 'code', 'div', 'em', 'figcaption',
  'figure', 'footer', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'header', 'hr', 'i', 'img', 'li', 'main', 'nav',
  'ol', 'p', 'pre', 's', 'section', 'small', 'span', 'strong', 'style', 'sub', 'sup', 'table', 'tbody', 'td',
  'tfoot', 'th', 'thead', 'tr', 'u', 'ul'
]);

export function isAllowedContentTag(tag: string): boolean {
  return allowedContentTags.has(tag);
}
